var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.10476 4.08446L8.97176 0.214455C9.03941 0.146486 9.11981 0.0925513 9.20837 0.0557484C9.29692 0.0189455 9.39187 0 9.48776 0C9.58366 0 9.6786 0.0189455 9.76716 0.0557484C9.85571 0.0925513 9.93611 0.146486 10.0038 0.214455C10.1398 0.352363 10.216 0.538267 10.216 0.731955C10.216 0.925644 10.1398 1.11155 10.0038 1.24946L5.62276 5.63346C5.48981 5.76614 5.31077 5.84239 5.12298 5.8463C4.93518 5.85022 4.75312 5.78149 4.61476 5.65446L0.20276 1.25246C0.0708167 1.11452 -0.00194043 0.930447 3.93703e-05 0.739578C0.00201917 0.548708 0.0785788 0.366184 0.213355 0.231015C0.348132 0.095847 0.530433 0.0187579 0.721296 0.016224C0.91216 0.0136902 1.09644 0.0859126 1.23476 0.217455L5.10476 4.08446Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/collapse-icon.009f6f2acb00939e7217a8439266e392.svg";
export { ForwardRef as ReactComponent };